export class Powertrain {
  name: string = "";
  code: string = "";
  contract: string = "2";
  desc: string = "";
  id: string = null;

  getName() {
    return this.name;
  }

  getCode() {
    return this.code;
  }

  getDesc() {
    return this.desc;
  }

  getId() {
    return this.id;
  }

  setName(name: string) {
    this.name = name;
  }

  setCode(code: string) {
    this.code = code;
  }

  setDesc(desc: string) {
    this.desc = desc;
  }

  setId(id: string) {
    this.id = id;
  }
}
